<template>
  <div class="layer-color-filter-element">
    <div class="calendar-selector" v-if="!hideCalendar">
      <div class="input_label">Selectează data</div>
      <div>
        <functional-calendar
          class="test_calendar_class"
          :date-format="'yyyy-mm-dd'"
          :is-date-range="true"
          v-model="date"
          :change-month-function="true"
          :change-year-function="true"
        ></functional-calendar>
      </div>
    </div>

    <div class="item-selector" v-if="hideCalendar || (!hideCalendar && dateRange)">
      <div class="2-step-filter pb-3" v-if="secondStep">
        <DxSelectBox
          :items="productTypes"
          :placeholder="$t('layer_colorizing.select')"
          valueExpr="value"
          displayExpr="label"
          v-model="selectedType"
        />
      </div>
      <div class="list-content">
        <div class="text-danger text-center" v-if="errorMessage">
          {{ errorMessage }}
        </div>
        <div class="loader text-center" v-if="loading && !errorMessage">
          <loader :loading="loading" size="sm"></loader>
        </div>
        <div
          class="list-results-filter"
          v-if="!loading && ((secondStep && selectedType && dateRange) || (!secondStep && dateRange) || hideCalendar)"
        >
          <div class="input-search" v-if="!hideSearch">
            <div class="search-row">
              <label>Căutare - {{ filteredItems.length ?? 0 }} rezultate</label>
              <label class="date-range-checkbox" v-if="showDateRangeCheckbox">
                <input
                  type="checkbox"
                  :checked="localDateRangeCheckbox"
                  @change="onDateRangeCheckboxChange"
                />
                <span>{{ dateRangeCheckboxLabel }}</span>
              </label>
            </div>
            <input type="text" v-model="filter" class="form-control" />
          </div>
          <div class="input-search-results">
            <div class="multiselect-container" v-if="multiSelect">
              <div class="multiselect-item" v-for="(item, index) in filteredItems" :key="index">
                <input type="checkbox" :value="item.uuid" v-model="item.selected" @change="onItemChanged" :disabled="item.disabled" />
                <span v-html="renderItem(item)" />
              </div>
            </div>
            <div class="single-container" v-else>
              <DxRadioGroup
                :items="filteredItems"
                v-model="selected"
                :display-expr="displayExpr ?? 'name'"
                :value-expr="valueExpr ?? 'uuid'"
                :item-template="renderItem"
                layout="vertical"
                class="input_color_holder"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DxRadioGroup from "devextreme-vue/radio-group";
import { FunctionalCalendar } from "vue-functional-calendar";
import moment from "moment";
import Loader from "@/components/Loader";
import DxSelectBox from "devextreme-vue/select-box";
import { mapGetters } from "vuex";
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    checkBoxAttributes: {
      type: Object,
      default: () => {},
    },
    displayExpr: {
      type: String,
      default: "name",
    },
    valueExpr: {
      type: String,
      default: "uuid",
    },
    color: {
      type: String,
    },
    hideCalendar: {
      type: Boolean,
      default: false,
    },
    hideSearch: {
      type: Boolean,
      default: false,
    },
    onDateSelected: {
      type: Function | null,
    },
    secondStep: {
      type: Boolean,
      default: false,
    },
    onProductTypeSelected: {
      type: Function | null,
    },
    errorMessage: {
      type: String | null,
    },
    multiSelect: {
      type: Boolean,
      default: false,
    },
    showDateRangeCheckbox: {
      type: Boolean,
      default: false,
    },
    dateRangeCheckboxValue: {
      type: Boolean,
      default: false,
    },
    dateRangeCheckboxLabel: {
      type: String,
      default: "Csak a kiválasztott dátumtartományban használt termékek",
    },
  },
  data() {
    return {
      checkBoxClass: {
        class: this.checkBoxAttributes,
      },
      local_items: this.items ?? [],
      filter: "",
      selected: null,
      date: {
        dateRange: {
          start: "",
          end: "",
        },
      },
      dateRange: null,
      loading: false,
      selectedType: null,
      productTypes: [
        { value: "fito", label: "Fito" },
        { value: "fertility", label: "Fertility" },
        { value: "stock", label: "Stoc" },
      ],
      localErrorMessage: this.errorMessage ?? null,
      localDateRangeCheckbox: this.dateRangeCheckboxValue,
    };
  },
  computed: {
    ...mapGetters({
      layers_loading: "layers/layers_loading",
    }),
    filteredItems() {
      return this.local_items.filter((item) => {
        if (this.filter) {
          return item.name.toLowerCase().trim().includes(this.filter.toLowerCase().trim());
        } else {
          return item;
        }
      });
    },
  },
  components: {
    DxSelectBox,
    DxRadioGroup,
    FunctionalCalendar,
    Loader,
  },
  methods: {
    renderItem(itemData) {
      return `<div class="custom-radio-item d-flex flex-row">
            <div class="color-dot" style="width: 16px; height: 16px; margin-right: 8px; background-color:${itemData.color}"></div>
            <div class="radio-label">${itemData.name}</div>
          </div>`;
    },
    getSelectedItems() {
      return this.filteredItems.filter((item) => item.selected);
    },
    onItemChanged(e) {
      const element = this.local_items.find((it) => it.uuid === e.target.value);
      element.selected = e.target.checked;

      if (this.multiSelect) {
        if (e.target.checked) {
          this.$emit("onSelect", element);
        } else {
          this.$emit("onDeselect", element);
        }

        this.$emit("onChange", this.getSelectedItems());
      }
    },
    onDateRangeCheckboxChange(e) {
      this.localDateRangeCheckbox = e.target.checked;
      this.$emit("onDateRangeCheckboxChanged", this.localDateRangeCheckbox);
    },
  },
  watch: {
    items: {
      handler: function (newVal) {
        this.local_items = newVal.map((item) => {
          if (!item.hasOwnProperty("selected")) {
            this.$set(item, "selected", false);
          }
          return item;
        });

        this.loading = false;
        this.localErrorMessage = null;
        this.$emit("onChange", this.getSelectedItems());
      },
      deep: true,
    },
    selectedType: {
      handler: function (newVal) {
        if (this.secondStep && this.selectedType && this.dateRange) {
          this.onProductTypeSelected(newVal, this.dateRange);
          this.loading = true;
        }
      },
      deep: true,
    },
    date: {
      handler: function (newVal) {
        if (newVal && newVal.dateRange && newVal.dateRange.start && newVal.dateRange.end) {
          this.dateRange = {
            date_from: moment(newVal.dateRange.start).format("YYYY-MM-DD"),
            date_to: moment(newVal.dateRange.end).format("YYYY-MM-DD"),
          };

          this.selectedType = null;

          if (this.onDateSelected instanceof Function) {
            this.onDateSelected(this.dateRange);
            this.loading = true;
          }
        }
      },
      deep: true,
    },
    selected: function (selectedUUID) {
      this.$emit("onSelect", selectedUUID);
    },
    errorMessage: function (newVal) {
      this.localErrorMessage = newVal;
    },
    dateRangeCheckboxValue: function (newVal) {
      this.localDateRangeCheckbox = newVal;
    },
    layers_loading: {
      handler: function (newVal) {
        this.loading = newVal;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.input-search-results {
  height: 200px;
  overflow-y: auto;
}

.multiselect-item {
  display: flex;
}

.search-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.date-range-checkbox {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  margin: 0;
  white-space: nowrap;
}
</style>
